import React, { Component } from "react";
import Radio from "./Radio";

class RadioGroup extends Component {
  constructor() {
    super();

    this.state = {
      selectedIndex: 1,
      selectedValue: "=",
      hoverValue: "=",
      options: ["+", "=", "-"]
    };
  }

  toggleRadio = index => {
    this.setState({
      selectedIndex: index,
      selectedValue: this.state.options[index],
      options: this.state.options
    });
  };

  getColorFromSymbol = symbol => {
    switch (symbol) {
      case "+":
        return "success";
      case "-":
        return "danger";
      default:
        return "light";
    }
  };

  changeColor = symbol => {
    if (symbol == this.state.hoverValue) {
      this.setState({ hoverValue: this.state.selectedValue });
    } else {
      this.setState({ hoverValue: symbol });
    }
  };

  render() {
    const { options } = this.state;

    const allOptions = options.map((option, i) => {
      return (
        <Radio
          key={i}
          isChecked={this.state.selectedIndex == i}
          selectedValue={this.state.selectedValue}
          text={option}
          color={this.getColorFromSymbol(this.state.hoverValue)}
          hoverColor={this.changeColor}
          index={i}
          handler={this.toggleRadio}
        />
      );
    });

    return (
      <div className="btn-group btn-group-sm col-4 radioGroup">
        {allOptions}
      </div>
    );
  }
}

export default RadioGroup;
